<ra-modal [title]="title() || ('shared.modalEditText.title' | translate)" [size]="modalSize()" (close)="onCancel()">

    @if (showLimitCharacters() && limitCharacters()) {
        <!-- Limit characters -->
        <div class="container-limit-characters">
            <ra-icon [icon]="'warning'" [varColor]="'contentSecondary'" [size]="16" />
            <p class="ra-label-s content-secondary">{{ 'common.charactersCount' | translate:{ current: editorValue().length, limit: limitCharacters() } }}</p>
        </div>
    }

    <!-- Editor de Texto -->
    <div class="modal-editor" [style.height.rem]="editorHeight() / 16">
        <textarea
            class="modal-textarea"
            [attr.placeholder]="placeholder() || ('shared.modalEditText.placeholder' | translate)"
            [attr.maxlength]="limitCharacters() || undefined"
            [ngModel]="editorValue()"
            (ngModelChange)="editorValue.set($event)">
        </textarea>
    </div>

    <!-- Actions -->
    <div class="modal-actions">
        <ra-button
            [label]="'common.cancel' | translate"
            [type]="'primary-outline'"
            (click)="onCancel()">
        </ra-button>

        <ra-button
            [label]="'common.save' | translate"
            [type]="'primary'"
            (click)="onSave()">
        </ra-button>
    </div>
</ra-modal>
